import { render, staticRenderFns } from "./ServiceSelectiveSurveyButton.vue?vue&type=template&id=58b15228"
import script from "./ServiceSelectiveSurveyButton.vue?vue&type=script&lang=js"
export * from "./ServiceSelectiveSurveyButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports